import { render, staticRenderFns } from "./SvgSection14b.vue?vue&type=template&id=1afa98e0&"
import script from "./SvgSection14b.vue?vue&type=script&lang=js&"
export * from "./SvgSection14b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports